import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useBestAvailableOrg } from "~/hooks/use-best-avalible-org";
import { useAuthContext } from "~/contexts/auth-context";

export const Route = createFileRoute("/docs/")({
  component: DocsRedirect,
});

function DocsRedirect() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuthContext();
  const bestOrgId = useBestAvailableOrg();

  useEffect(() => {
    if (isLoading) return;

    if (!isAuthenticated) {
      window.location.href = "/";
      return;
    }

    if (bestOrgId) {
      navigate({
        to: "/org/$org/docs",
        params: { org: bestOrgId },
        replace: true,
      });
    }
  }, [isLoading, isAuthenticated, bestOrgId, navigate]);

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4" />
        <p className="text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
}
